<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_toc_2">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_toc_3">Dedication</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_toc_4">Acknowledgments</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#auto_bookmark_toc_5">Author’s Note</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#auto_bookmark_toc_6">Last Call</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007#auto_bookmark_toc_7">In the Cold and Dark</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0008#auto_bookmark_toc_8">Strange Awakenings</a></p>
<p class="P_TOC_Entry_1"><span href="#/section0009#auto_bookmark_toc_9" title="Link target outside of Sample">Boris and Natasha</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0010#auto_bookmark_toc_10" title="Link target outside of Sample">Neglecting a Civic Duty</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0011#auto_bookmark_toc_11" title="Link target outside of Sample">One Little Slip</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0012#auto_bookmark_toc_12" title="Link target outside of Sample">There’s Something to be Said About Accepting Your Fate</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0013#auto_bookmark_toc_13" title="Link target outside of Sample">Helplessly Hoping</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0014#auto_bookmark_toc_14" title="Link target outside of Sample">Like it Was Normal</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0015#auto_bookmark_toc_15" title="Link target outside of Sample">As the Kitten Grows</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0016#auto_bookmark_toc_16" title="Link target outside of Sample">Kittens and their Dagger-Like Claws</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0017#auto_bookmark_toc_17" title="Link target outside of Sample">Another Box</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0018#auto_bookmark_toc_18" title="Link target outside of Sample">In Which Killian Kills Nobody</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0019#auto_bookmark_toc_19" title="Link target outside of Sample">The Boiling Fury of a Cold Fish</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0020#auto_bookmark_toc_20" title="Link target outside of Sample">Easter Egg Hunt</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0021#auto_bookmark_toc_21" title="Link target outside of Sample">Frances’s Best Present—Merry Couplemas 3</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0022#auto_bookmark_toc_22" title="Link target outside of Sample">Still in a Holiday Story Mood? Read on for an Excerpt from ChrisMyths by Amy Lane.</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0025#auto_bookmark_toc_25" title="Link target outside of Sample">About the Author</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0026#auto_bookmark_toc_26" title="Link target outside of Sample">By Amy Lane</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0027#auto_bookmark_toc_27" title="Link target outside of Sample">More from Amy Lane</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0028" title="Link target outside of Sample">Visit Dreamspinner Press</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0029#auto_bookmark_toc_30" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?63c8dd22